import {AfterViewInit, Component, ElementRef, Input, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {AiGlobalChatService} from './ai-global-chat.service';
import {CommonModule, NgFor, NgIf} from '@angular/common';
import {UrlBuilderService} from '../services/url-builder.service';
import {environment} from '../../environments/environment';
import {catchError, finalize, take, tap} from 'rxjs/operators';
import {Subscription, throwError} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {AppState} from '../store';
import {TenantService} from '../services/tenant.service';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MessagesService} from '../shared/services/messages.service';
import {MatDialog} from '@angular/material/dialog';
import {FormsModule} from '@angular/forms';
import {selectUser} from '../store/selectors';
import {AiChatEvent, ChatMessage} from './ai-chat-event.model';
import {collectionSnapshots} from '@angular/fire/firestore';
import {AiChatDetail, AiChatSummary} from './ai-chat-log.model';
import {LoadingService} from '../shared/services/loading.service';
import {delay} from '../common/generic-utils';
import {SafeHtmlPipe} from '../shared/pipes/safe-html.pipe';

import copy from 'copy-to-clipboard';

@Component({
  selector: 'ai-global-chat',
  templateUrl: './ai-global-chat.component.html',
  styleUrls: ['./ai-global-chat.component.scss'],
  imports: [
    CommonModule,
    NgIf,
    NgFor,
    FormsModule,
    SafeHtmlPipe
  ],
  standalone: true
})
export class AiGlobalChatComponent implements OnInit, OnDestroy {

  aiPromptId: string;

  inputValue: string;

  newMsgIconUrl: string;
  logMsgIconUrl: string;
  sidebarIconUrl: string;
  magicWandIconUrl: string;
  resizeMinIconUrl: string;
  resizeMaxIconUrl: string;
  closeIconUrl: string;
  emptyChatIconUrl: string;
  tenantPictureUrl: string;
  sendIconImgUrl: string;
  warningIconUrl: string;
  loadingGifUrl: string;
  receiveCurveImgUrl: string;
  sendCurveImgUrl: string;
  receiverImgUrl: string;
  copyIconUrl: string;

  isSidebarHidden: boolean = false;
  isMinMAx: boolean = false;

  showMessages: boolean = false;
  currentUser: any;
  isAiLoading: boolean = false;
  displayInitialMessage: boolean = true;

  chatHistory: ChatMessage[] = [];
  aiChatSessionId: string = null;
  messageFromUser: string = '';
  countdownInterval: any;
  countdown: number;
  aiEndpoint: string = environment.api.startAiChatSessionUrl;
  welcomeMessage: string = '';
  @ViewChild('messageContainer') messageContainer: ElementRef;
  chatSummary: AiChatSummary[] = [];
  chatSummary24: AiChatSummary[] = [];
  chatSummary48: AiChatSummary[] = [];
  chatSummary72: AiChatSummary[] = [];
  chatSummary168: AiChatSummary[] = [];

  @ViewChild('chatInput')
  chatInput: ElementRef;

  aiChatServiceSubscription: Subscription;
  initialMessageShown = true;
  private promptParams: any;
  summarySelected: any;

  constructor(
    public aiGlobalChatService: AiGlobalChatService,
    private ub: UrlBuilderService,
    private store: Store<AppState>,
    private tenant: TenantService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private messages: MessagesService
  ) {

  }

  ngOnInit() {

    this.resetChat();

    this.store.pipe(select(selectUser))
      .subscribe(user => {
        this.currentUser = user;

        this.tenantPictureUrl = this.currentUser.pictureUrl ?? this.ub.buildImageUrl('/images/och-ai-suggestions/empty-img.svg');
      });
    console.log('currentUser', this.currentUser);
    console.log('tenant', this.tenant);


    this.newMsgIconUrl = this.ub.buildImageUrl('/images/common/new-msg.svg');
    this.logMsgIconUrl = this.ub.buildImageUrl('/images/common/log-msg.svg');
    this.magicWandIconUrl = this.ub.buildImageUrl('/images/common/magic-wand.svg');
    this.resizeMinIconUrl = this.ub.buildImageUrl('/images/common/resize-min.svg');
    this.resizeMaxIconUrl = this.ub.buildImageUrl('/images/common/resize-max.svg');
    this.closeIconUrl = this.ub.buildImageUrl('/images/common/close.svg');
    this.sidebarIconUrl = this.ub.buildImageUrl('/images/common/Sidebar.svg');
    this.emptyChatIconUrl = this.ub.buildImageUrl('/images/common/empty-chat-owl.jpg');
    this.sendIconImgUrl = this.ub.buildImageUrl('/images/och-ai-suggestions/send-icon.svg');
    this.warningIconUrl = this.ub.buildImageUrl('/images/och-ai-suggestions/Warning.svg');
    this.loadingGifUrl = this.ub.buildImageUrl('/images/common/loading.gif');
    this.copyIconUrl = this.ub.buildImageUrl('/images/common/Copy.svg');
    this.receiverImgUrl = this.ub.buildImageUrl('/images/och-ai-suggestions/receiver-img.svg');

    this.sendCurveImgUrl = this.ub.buildImageUrl('/images/common/sender-curve.svg');
    this.receiveCurveImgUrl = this.ub.buildImageUrl('/images/common/receiver-curve.svg');

    this.aiChatServiceSubscription = this.aiGlobalChatService.showGlobalAiChat$
      .subscribe(async (event: AiChatEvent) => {

        this.resetChat(!event?.config?.initialUserMessage);

        if (event.show) {

          this.setFocusToChatInputBox();

          this.welcomeMessage = event?.config?.welcomeMessage;
          this.aiPromptId = event?.config?.promptId;
          this.promptParams = event?.config?.promptParams;

          console.log('aiPromptId', this.aiPromptId);

          await this.getAiChatSummary();

        }

        if (event.config?.initialUserMessage) {
          this.inputValue = event.config?.initialUserMessage;
          this.callGptApi(false);
        }

      });

  }

  ngOnDestroy() {
    this.aiChatServiceSubscription.unsubscribe();
  }

  setFocusToChatInputBox() {
    setTimeout(() => {
      const input = document.getElementById('chatInput');
      if (input) {
        input.focus();
      }
    });
  }

  async getChatSessionDetail(sessionId: string, target: HTMLElement) {

    try {

      this.aiChatSessionId = sessionId;
      this.showMessages = false;
      this.isAiLoading = true;

      this.summarySelected?.removeAttribute('style');
      this.summarySelected = target

      const chatDetail = await this.aiGlobalChatService.getAiChatDetail(this.tenant.id, sessionId);

      console.log('######chatDetail', chatDetail);

      if (!chatDetail[0]?.messages) {
        console.log(`No messages available, returning...`);
        return;
      }

      this.chatHistory = chatDetail[0].messages;
      this.showMessages = true;
      this.messageFromUser = this.chatHistory[this.chatHistory.length - 2].content;

      this.summarySelected.style.backgroundColor = '#E3F0FA';
      this.summarySelected.style.borderRadius = '10px';



      window.scrollTo(0, 0);

    } catch (error) {
      console.log('error', error);

    } finally {
      this.isAiLoading = false;
      this.initialMessageShown = false;
      this.displayInitialMessage = false;
    }

  }

  isWithinDateRange(data: any): string {
    const currentDate = new Date();
    const firestoreDate = data.createdAt.toDate();

    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();

    const firestoreYear = firestoreDate.getFullYear();
    const firestoreMonth = firestoreDate.getMonth();
    const firestoreDay = firestoreDate.getDate();

    if (currentYear === firestoreYear && currentMonth === firestoreMonth && currentDay === firestoreDay) {
      return 'today';
    } else if (currentYear === firestoreYear && currentMonth === firestoreMonth && currentDay - firestoreDay === 1) {
      return 'yesterday';
    } else if (currentDate.getTime() - firestoreDate.getTime() <= 3 * 24 * 60 * 60 * 1000) {
      return 'previous3days';
    } else if (currentDate.getTime() - firestoreDate.getTime() <= 7 * 24 * 60 * 60 * 1000) {
      return 'previous7days';
    } else {
      return 'previous30days';
    }
  }

  restartChatSession() {

    this.resetChat();

    this.aiGlobalChatService.endGlobalAiChatSession();

    this.aiGlobalChatService.startDefaultAiChatSession();

  }

  callGptApi(retry: boolean) {

    this.showMessages = false;

    if (this.aiChatSessionId) {
      this.aiEndpoint = environment.api.continueAiChatSessionUrl;
    }

    try {

      if (this.inputValue) {
        this.messageFromUser = `${this.inputValue}`;
      }

      if (this.inputValue || retry) {

        this.showMessages = true;
        this.isAiLoading = true;
        this.countdown = 0;

        this.countdownInterval = setInterval(() => {
          this.countdown++;
          this.scrollToLastMessage();
        }, 1000);

        this.http.post(this.aiEndpoint, {
          tenantId: this.tenant.id,
          newChatMessage: this.messageFromUser,
          initialPromptId: this.chatHistory.length === 0 ? this.aiPromptId : null,
          promptParams: this.promptParams,
          aiChatSessionId: this.aiChatSessionId
        })
          .pipe(
            tap((res: any) => {

              console.log('result from ai:', res);

              if (res.status === 'success') {

                this.chatHistory = res.chatHistory;

                if (!this.aiChatSessionId) {

                  this.aiChatSessionId = res.aiChatSessionId;

                  console.log('aiChatSessionId', this.aiChatSessionId);

                  this.getAiChatSummary().then(() => {});
                }
              }

              this.scrollToLastMessage();

            }),
            catchError(err => {

              console.log('Error sending message', err);
              this.messages.error(`Could not create suggestions, please try again in a few seconds.`);
              // this.chatHistory.push({'role': 'user', 'content': `${this.messageFromUser}`});
              this.showMessages = true;

              return throwError(err);
            }),
            finalize(() => {
                this.isAiLoading = false;
                clearInterval(this.countdownInterval);
              }
            ))
          .subscribe();

        this.scrollToLastMessage();

        if (this.countdown >= 3) {
          this.scrollToLastMessage();
        }

      } else {
        this.snackBar.open('Please tell the AI what you are looking for.', 'Close', {duration: 3000});
        if (this.chatHistory.length == 0) {
          this.showMessages = false;
        }
      }

      if (this.showMessages) {
        this.inputValue = '';
      }
    } catch (error) {
      if (this.showMessages) {
        this.inputValue = '';
        clearInterval(this.countdownInterval);
      }
    }

  }

  scrollToLastMessage() {
    setTimeout(() => {
      const messageContainer = document.querySelector('.message-box .messages-container');
      messageContainer.scrollTop = messageContainer.scrollHeight;
    });
  }


  copyToClipboard(chat: string) {
    copy(chat);
    this.snackBar.open(` Copied to clipboard`, 'Close', {duration: 3000});
  }

  toggleMin(): void {
    this.isMinMAx = true;
    // document.body.style.overflow = 'visible';
  }

  toggleMax() {
    this.isMinMAx = !this.isMinMAx;
    // document.body.style.overflow = 'hidden';
  }

  toggleSidebar(): void {
    this.isSidebarHidden = !this.isSidebarHidden;
  }

  closeAiChat(): void {
    this.aiGlobalChatService.endGlobalAiChatSession();
  }

  insertLineBreaks(input: string): string {
    return input.replace(/\n/g, '<br>');
  }

  resetChat(displayInitialMessage: boolean = true) {

    this.inputValue = null;
    this.showMessages = false;
    this.isAiLoading = false;
    this.displayInitialMessage = displayInitialMessage
    this.chatHistory = [];
    this.aiChatSessionId = null;
    this.messageFromUser = '';
    this.aiEndpoint = environment.api.startAiChatSessionUrl;
    this.welcomeMessage = '';
    this.chatSummary = [];
    this.chatSummary24 = [];
    this.chatSummary48 = [];
    this.chatSummary72 = [];
    this.chatSummary168 = [];
  }

  async getAiChatSummary() {

    this.isAiLoading = true;

    const chatLogSummary = await this.aiGlobalChatService.getAiChatSummary(this.tenant.id);

    console.log('chatLogSummary', chatLogSummary);

    this.chatSummary24 = [];
    this.chatSummary48 = [];
    this.chatSummary168 = [];
    this.chatSummary = [];

    for (let chatSummary of chatLogSummary) {

      const res = this.isWithinDateRange(chatSummary);

      if (res === 'today') {

        this.chatSummary24.push(chatSummary);
      } else if (res === 'yesterday') {
        this.chatSummary48.push(chatSummary);
      } else if (res === 'previous3days') {
        this.chatSummary72.push(chatSummary);
      } else if (res === 'previous7days') {
        this.chatSummary168.push(chatSummary);
      } else {
        this.chatSummary.push(chatSummary);
      }
    }
    this.isAiLoading = false;
  }
  aiLearnMore() {
    window.open('https://help.onlinecoursehost.com/article/148-ai-course-creation-assistant', '_blank');
  }
}
